import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { dirFor, isLocale, normalizeLocale } from "@/lib/i18n";

export const Route = createFileRoute("/{-$locale}")({
  staticData: { sitemap: false },
  beforeLoad: ({ params }) => {
    const locale = (params as { locale?: string }).locale;
    if (locale !== undefined && !isLocale(locale)) throw notFound();
  },
  component: LocaleLayout,
});

function LocaleLayout() {
  const { locale } = Route.useParams();
  const active = normalizeLocale(locale);

  return (
    <div lang={active} dir={dirFor(active)} className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
